const teal = {
    100: 'rgb(164, 244, 244)',
    200: 'rgb(127, 240, 240)',
    300: 'rgb(91, 236, 236)',
    400: 'rgb(54, 231, 231)',
    500: 'rgb(26, 219, 219)',
    600: 'rgb(21, 183, 183)',
    700: 'rgb(17, 146, 146)',
    800: 'rgb(13, 110, 110)',
};
export default teal;
